import api from '@/api'
import { SoilLayers } from './constants'

function checkInitialN (value) {
  if (value < 0) {
    throw new Error('Invalid initial N value')
  } else {
    return value
  }
}

export default {
  namespaced: true,
  state: {
    types: [],
    type: null,
    layers: 4,
    thickness: 10,
    initialN: ['I (0-30cm)', 'II (31-60cm)', 'III (61-100cm)'].map(label => ({ label, amount: 0 }))
  },
  mutations: {
    setTypes (state, types) {
      if (!Array.isArray(types)) {
        throw new Error('Invalid types')
      }
      state.types = types
    },
    setType (state, type) {
      const found = state.types.find((current) => current.id === type)
      if (!found) {
        throw new Error(`Invalid type "${type}"`)
      }
      state.type = found
    },
    setInitialN (state, { index, value }) {
      state.initialN[index].amount = checkInitialN(value)
    },
    setLayers (state, layers) {
      if (layers < SoilLayers.MINIMUM
      || layers > SoilLayers.MAXIMUM) {
        throw new Error('Invalid amount of layers')
      }
      state.layers = layers
    }
  },
  actions: {
    async loadTypes ({ commit }, region) {
      const types = await api.loadSoilTypes(region)
      commit('setTypes', types)
    }
  }
}
